import { useTranslation } from '@/lib/i18n/i18n.client';

import Card from '@/decodo/components/atoms/Card';
import { Text } from '@/decodo/components/atoms/Text';

import FileSearchIcon from '~/icons/file-search-01.svg';

const NoTemplatesFound = () => {
  const { texts } = useTranslation();
  return (
    <div className='text-center'>
      <Card
        classNames={{
          root: 'mx-auto shadow-none bg-gray-100 p-4 w-fit border-none',
        }}
      >
        <FileSearchIcon className='h-32 w-32 text-gray-500' />
      </Card>
      <Text
        variant='body-l'
        color='gray-500'
        classNames={{
          wrapper: 'mb-3 mt-6',
        }}
      >
        {texts.feature_library.no_templates_found_title}
      </Text>
      <Text className='text-h4 font-serif'>
        {texts.feature_library.no_templates_found_desc}
      </Text>
    </div>
  );
};

export default NoTemplatesFound;
